import { type Component, Show, type VoidComponent } from "solid-js";
import { Key } from "@solid-primitives/keyed";
import EditorMenu from "../editor/EditorMenu";
import RulesMenu from "../rules/RulesMenu";
import type { SubformEditorTab } from "../subforms/types";

type MenuItemKey = "fields" | "subforms" | "rules" | "integrations" | "settings" | "variables" | "validation";

export type SideNavContentSlotProps = {
  isActive: boolean;
};
type SideNavContentProps = {
  activeItem: MenuItemKey | SubformEditorTab;
};
type SideNavContentItem = {
  key: MenuItemKey | SubformEditorTab;
  Slot: VoidComponent<SideNavContentSlotProps>;
};

export const SideNavContent: Component<SideNavContentProps> = (props) => (
  <aside class="flex h-full flex-col overflow-hidden">
    <Key<SideNavContentItem>
      each={[
        { key: "fields", Slot: EditorMenu },
        { key: "rules", Slot: RulesMenu },
      ]}
      by="key"
    >
      {(item) => {
        const { Slot } = item();
        return (
          <Show when={props.activeItem === item().key}>
            <div class="h-full w-80 border-r border-subtle bg-surface-default">
              <Slot isActive={props.activeItem === item().key} />
            </div>
          </Show>
        );
      }}
    </Key>
  </aside>
);
